const PressReleaseTypes = {
  '1894730b84504b978b97db29e88e1b9e': 'article',
  b72d460897374a3fb7b0868b77dd3a04: 'podcast',
  '29171dc1f659434a97938edd14499b36': 'video',
};

export default PressReleaseTypes;
